/**
 * ARC brand palette — use THEME in JS; mirror hex in theme.css :root for CSS var().
 */
export const THEME = {
  primary: "#0B1F3A",
  secondary: "#112B4C",
  tableMuted: "#6C8A9B",
  surface: "#F2F4F7",
  text: "#2D3748",
};

const COLORS = {
  IN_PROGRESS: "#FFBF00",
  ERROR: "#ce0000",
  QUEUED: "yellow",
  COMPLETED: "#29b160",
  WITH_ERROR: "#ed917a",
};

export default COLORS;
